export enum MemberTypeId {
    Parent = 0,
    Student = 1,
    Staff = 2,
    SysAdmin = 3,
    Unknown= 4
}
